import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../auth/authconfig";

const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Gets the current access token for API calls
 * Returns null if no account is logged in
 */
export const getAccessToken = async (): Promise<string | null> => {
  await msalInstance.initialize();
  const account = msalInstance.getActiveAccount();
  
  if (!account) {
    console.warn('No active account found');
    return null;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ["openid", "profile"],
      account: account
    });
    
    return response.idToken;  // Use idToken instead of accessToken
  } catch (error) {
    console.error('Failed to acquire token silently:', error);
    try {
      const response = await msalInstance.acquireTokenPopup({
        scopes: ["openid", "profile"],
        account: account
      });
      return response.idToken;  // Use idToken instead of accessToken
    } catch (popupError) {
      console.error('Failed to acquire token interactively:', popupError);
      return null;
    }
    
  }
};